
/* ------------------------------------------------------------------------ */
/*		File: Courses.tsx                                                   */
/*		Description: Courses page definition                                */
/*		Project: iSymWebSchool											    */
/*		Author: ISym Global Solutions Limited                               */
/*		Version: 1.0													    */
/* ------------------------------------------------------------------------ */

/* eslint-disable react/jsx-pascal-case */

import React from "react";
import Menu from "../../components/cmpMenu/cmpMenu";
import IntroComponent from "../../components/cmpIntro/cmpIntro";
import Card_545 from "../../components/cmpCard_545/cmpCard_545";
import { useTranslation, withTranslation } from "react-i18next";

import "../../scss/general.css";
import "./courses.css";
import Card_Breadcumb from "../../components/cmpBreadcumb/cmpBreadcumb";
import Meta from "../../components/GenericComponents/meta";


/* ------------------------------------------------------------------------ */


const Courses: React.FC = () => {
    const { t } = useTranslation();

    const infoMenus:any = t("menu", { returnObjects: true }); 
    const infoCourses:any = t("courses", { returnObjects: true });
    const detailMenu = infoMenus.filter((x:any) => x.id === "courses")[0] || null;

    return (
        <div className="header-parent">
            <Meta page={"courses"} />
            <div className="cssCourses">
                <Menu 
                    label={detailMenu!.label}
                    options={detailMenu!.submenus}
                    buttons={detailMenu!.buttons}
                    quotation={detailMenu!.quotation}
                />
                <section id="courses">
                    <div className="cssCol">
                        <Card_Breadcumb label={infoCourses.breadcumb} />

                        {/* Section: Courses */}
                        <IntroComponent
                            label={infoCourses.label}
                            description={infoCourses.description}
                        />

                        <div className="cssRowBetween courses_container">
                            {infoCourses.content.map((item:any, index:any) => (
                                <Card_545  
                                    key={`courses-${index}`}
                                    card={item} 
                                />      
                            ))}
                        </div>  
                    </div>      
                </section>          
            </div>
        </div>
    );  
};

export default withTranslation('translation', { withRef: true }) (Courses);